import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Navigationbar from '../components/Navigationbar';
import Footer from '../components/Footer';
import Apiservice from '../services/Apiservice';
import CommonFunctions from '../components/CommonFunctions';

const TeamSquads = () => {
  const [tournamentId, setTournamentId] = useState(3); // Set your default tournament ID here
  const [posts, setPosts] = useState([]);
  const [teams, setTeams] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch teams and players data from your PHP API using Axios
        const response = await Apiservice.getTeamSquads(tournamentId);
        // Update the state with the fetched data
        setPosts(response.data.posts);
        setTeams(response.data.teams);
        setError(null);
      } catch (error) {
        // Handle errors
        setError('Error fetching data');
        console.error('Error fetching data:', error);
      }
    };

    // Call fetchData function
    fetchData();
  }, [tournamentId]); // Run when tournamentId changes

  return (
    <React.Fragment>
      <div className="bg-fluid"></div>
      <Navigationbar />
      <div className='container-fluid'>
        <nav aria-label="breadcrumb" className='mx-3'>
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><Link to="/" className="text-muted text-decoration-none">Home</Link></li>
            <li className="breadcrumb-item text-white active" aria-current="page">WPL Team Squads</li>
          </ol>
        </nav>

        <div className='row'>
          <div className='col-md-12'>
            <h1 className='fs-4 text-white'>Women's Premier League 2025 Team Squads</h1>
            <div className='card'>
              <div className='card-body'>
                {/* Dropdown for tournament selection */}
                <select 
                  value={tournamentId} 
                  onChange={(e) => setTournamentId(e.target.value)} 
                  className="form-select mb-3"
                >
                  <option value="1">WPL Tournament 1 - Squad</option>
                  <option value="2">WPL Tournament 2 - Squad</option>
                  <option value="3">WPL Tournament 3 - Squad</option>
                  {/* Add more tournaments as needed */}
                </select>
                
                <ul className="nav nav-pills mb-3" id="pills-tab" role="tablist">
                  {teams.map((team, index) => (
                    <li className="nav-item" role="presentation" key={index}>
                      <button 
                        className={`nav-link ${index === 0 ? 'active' : ''}`} 
                        id={`pills-tab-${index}`} 
                        data-bs-toggle="pill" 
                        data-bs-target={`#pills-pane-${index}`} 
                        type="button" 
                        role="tab" 
                        aria-controls={`pills-pane-${index}`} 
                        aria-selected={index === 0}
                      >
                        {team.team_shortcode}
                      </button>
                    </li>
                  ))}
                </ul>
                <div className="tab-content" id="pills-tabContent">
                  {teams.map((team, index) => (
                    <div 
                      className={`tab-pane fade ${index === 0 ? 'show active' : ''}`} 
                      id={`pills-pane-${index}`} 
                      role="tabpanel" 
                      aria-labelledby={`pills-tab-${index}`} 
                      key={index}
                    >
                      <h2 className='fs-5 mb-4'>{team.team_name} Team Squad</h2>
                      <div className='row'>
                        {team.players.map((player, i) => (
                          <div className='col-md-3' key={i}>
                            <div className="d-flex shadow border rounded mb-3">
                              <div className="flex-shrink-0">
                                <img 
                                  className={`team-${team.team_shortcode.toLowerCase()}`} 
                                  src={`images/players/${(player.player_name).toLowerCase().replace(/\s+/g, '-')}.webp`} 
                                  alt={`${player.player_name}`} 
                                  style={{ width: '75px' }} 
                                  onError={(e) => { e.target.onerror = null; e.target.src = 'images/players/default.webp'; }} 
                                />
                              </div>
                              <div className="flex-grow-1 ms-3">
                                <p className='mb-0'>{player.player_name}</p>
                                {(player.role !== null) ? <React.Fragment><small className='text-muted'>{player.role}</small><br/></React.Fragment> : ''}
                                <small className='text-muted'>{player.country}</small>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>                                
              </div>
            </div>
          </div>
          <div className='col-md-12'>
            <hr />
            <h2 className='fs-5'>News &amp; Updates</h2>
            <div className='row'>
              {posts && posts.map((item, index) => (
                <div className='col-md-3 mb-4' key={index}>
                  <div className="card shadow h-100">
                    <img src={`http://wplcricinfo.com/wpl/admin/${item.imgUrl}`} className="card-img-top" alt={item.title} />
                    <div className="card-body p-2 h-100">
                      <h3 className="card-title fs-6">
                        <Link className="text-decoration-none" to={`/post/${item.id}/${CommonFunctions.formatPostTitleForLink(item.title)}`}>
                          {item.title}
                        </Link>
                      </h3>
                      <p className="card-text">
                        <small className="text-body-secondary">
                          Posted on: {CommonFunctions.getPostDateFormat(item.created_at)}
                        </small>
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </React.Fragment>
  );
}

export default TeamSquads;